import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMeetingMinutes = createAsyncThunk("fetchMeetingMinutes", async ({ id }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.get(`meeting/minutes/${id}`, config);
	return response.data.data;
});

const MeetingMinutesListSlice = createSlice({
	name: "MeetingMinutesListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchMeetingMinutes.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMeetingMinutes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchMeetingMinutes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default MeetingMinutesListSlice.reducer;
